<template>
  <div id = "editLogsView">
<section class="toolbar">
         <div class="toolbar-container">
                <router-link id="back-button-edit-logs-view" v-bind:to="'/operator/pre-log-summary?selected_date='+this.$route.query.selected_date+'&from_date=' + this.$route.query.from_date + '&to_date=' + this.$route.query.to_date"><img src="/static/images/back.png"></router-link>
                <h1>{{ this.$route.query.selected_date }}</h1>
            </div>
      </section>
      
      <section class="editlogs">
         <div class="table-responsive">
         <table class="table table-hover">
         <thead>
      <tr>
        <th>Status</th>
        <th>Start</th>
        <th>Stop</th>
        <th>Action</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(item,index) in logArray">
        <td v-if="checkStatus(item)">{{item.DutyStatus}}</td>
        <td v-else>shift {{item.DutyStatus}}</td>
        <td v-if="checkStatus(item)">{{item.FormattedStartTime}}</td>
        <td v-else>--:--</td>
        <td v-if="checkStatus(item)">{{item.FormattedStopTime}}</td>
        <td v-else>--:--</td>
        <td class="editlog-center"><a v-if="checkStatus(item)" :id="index" :href="'/operator/edit-status-log?logId='+item.Id+'&startTime='+item.FormattedStartTime+'&stopTime='+item.FormattedStopTime+'&status='+item.DutyStatus+'&annotation='+item.Annotation+'&selected_date='+context.$route.query.selected_date+'&from_date='+context.$route.query.from_date+'&to_date='+ context.$route.query.to_date+'&index='+index+'&len='+(logArray.length-1)+'&before_shift_critical='+checkShiftCriticalBefore(index,logArray)+'&after_shift_critical='+checkShiftCriticalAfter(index,logArray)+'&startLimit='+placeStartLimit(index,logArray)+'&stopLimit='+placeStopLimit(index,logArray)"><img src="/static/images/edit.png" alt="Edit"></a></td>
      </tr>  
    </tbody>


         </table>
         </div>
      </section>
      <div class="custom-loading" v-if="this.$config.loading">
      <div class="custom-loading-box">
         <i class="fa fa-truck faa-passing-reverse animated " aria-hidden="true"></i>
      </div>
      </div>
    </body>
  </div>
  </div>
</template>

<script>
// +'&startLimit='+placeStartLimit(index,logArray)+'&stopLimit='+placeStopLimit(index,logArray)
export default {
  name: "editLogsView",
  template: "#editLogsView",
  data: () => ({
    logArray: [],
    EditedLogID: "",
    context: null
  }),
  mounted() {
    this.context = this;
    this.call();
  },
  methods: {
    call: function() {
      var self = this;self.$config.loading=true;
      //console.log(self.$route);
      $.ajax({
        url:
          self.$config.API +
          "/v1/operator/edit-log?selected_date=" +
          self.$route.query.selected_date +
          "&from_date=" +
          self.$route.query.from_date +
          "&to_date=" +
          self.$route.query.to_date,
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },timeout: 10000,
        success: function(res) {
          console.log(res);
          self.$config.loading=false;
          if(res.code == 200) {
            self.logArray = res.data.logs;
          } else if(res.code == 204) {
            alert("No Logs to edit.");
          }
        },
        error: function(res, textstatus) {self.$config.loading=false;if(textstatus==="timeout") {
            alert("Request timeout");
        } else {
            console.log("Error"+textstatus);
            alert(textstatus);
        }}
      });
    },
    checkShiftCriticalBefore: function(index, arr) {
      if (index == arr.length - 1) {
        return 0;
      }
      if (
        arr[index + 1].DutyStatus == "stop" ||
        arr[index + 1].DutyStatus == "start"
      ) {
        return 1;
      }
      return 0;
    },
    checkShiftCriticalAfter: function(index, arr) {
      if (index == 0) {
        return 0;
      }
      if (
        arr[index - 1].DutyStatus == "stop" ||
        arr[index - 1].DutyStatus == "start"
      ) {
        return 1;
      }
      return 0;
    },
    placeStopLimit: function(index, arr) {
      for (var i = index; i < arr.length; i++) {
        if (arr[i].DutyStatus == "start" || arr[i].DutyStatus == "stop") {
          return arr[i].FormattedStartTime;
        }
      }
      return 0;
    },
    placeStartLimit: function(index, arr) {
      for (var i = index; i >= 0; i--) {
        if (arr[i].DutyStatus == "start" || arr[i].DutyStatus == "stop") {
          return arr[i].FormattedStartTime;
        }
      }
      return 0;
    },
    checkStatus: function(e) {
      if (e.DutyStatus == "start" || e.DutyStatus == "stop") {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editLogsView.vue